import { SET_SUMMARIES } from 'actionTypes';

const initialState = {
  topRecommendationsTotal: 0,
  categories: {},
  subcategories: {},
  cities: {},
  provinces: {},
  universities: {},
  topTags: {
    categories: [],
    subcategories: [],
    cities: [],
    provinces: [],
    universities: [],
  },
};

export default function summaryReducer(state = initialState, action) {
  const { type, summaries } = action;
  if (type === SET_SUMMARIES) {
    if (summaries) {
      return summaries;
    } else {
      return initialState;
    }
  } else {
    return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/entities/summaryReducer.js